<template>
  <div class="web">
    <el-row :gutter="20">
      <el-col :span="19">

        <div class="resume" v-loading="loading">
          <div class="resumeContent">
            <div class="resumeAvatar" @click="openAvatar(resume.avatar)">
              <el-avatar :size="100" class="avatar">
                <img slot="default" :src="resume.avatar" alt="" style="width: 100%">
              </el-avatar>
              <i :class="resume.sex === '男'?'el-icon-male man':'el-icon-female girl'"></i>
            </div>
            <div class="resumeContentBox">
              <div>{{resume.vita_name}}</div>
              <div class="resumeContentText">
                <span>
                  <i class="el-icon-date"></i>
                  {{resume.birthyear}}
                </span>
                <el-divider direction="vertical"></el-divider>
                <span>
                  <i class="el-icon-school"></i>
                  {{resume.education}}
                </span>
                <el-divider direction="vertical"></el-divider>
                <span>
                  <i class="el-icon-suitcase"></i>
                  {{resume.worktime}}
                </span>
              </div>
              <div class="resumeContentText">
                <span>
                  <i class="el-icon-mobile-phone"></i>
                  {{resume.mobile}}
                </span>
                <el-divider direction="vertical"></el-divider>
                <span v-if="resume.members_state">
                  <i class="el-icon-user"></i>
                  {{memberList[resume.members_state].name}}
                </span>
              </div>
            </div>
          </div>
          <div class="resumeBox" v-if="resume.job_confim !== undefined && resume.job_confim.length > 0">
            <div class="resumeTitle">证书</div>
            <div class="resumeIn">
              <el-tag type="success" v-for="(item, index) in resume.job_confim" :key="index">{{item}}</el-tag>
            </div>
          </div>
          <div class="resumeBox" v-if="resume.selftags !== undefined && resume.selftags.length > 0">
            <div class="resumeTitle">个人标签</div>
            <div class="resumeIn">
              <el-tag v-for="(item, index) in resume.selftags" :key="index">{{item}}</el-tag>
            </div>
          </div>
          <div class="resumeBox">
            <div class="resumeTitle">求职期望</div>
            <div class="resumeIn">
              <span>
                <i class="el-icon-collection"></i>
                {{resume.desired_position}}
              </span>
              <el-divider direction="vertical"></el-divider>
              <span>
                <i class="el-icon-money"></i>
                {{resume.ideamoney}}{{resume.ideamoney === '面议'?'':'元/月'}}
              </span>
              <el-divider direction="vertical"></el-divider>
              <span>
                <i class="el-icon-location-outline"></i>
                {{resume.province_name?resume.province_name:''}}{{resume.city_name?resume.city_name:''}}{{resume.dist_name?resume.dist_name:''}}
              </span>
            </div>
          </div>
          <div class="resumeBox" v-if="resume.education_experience !== undefined && resume.education_experience.length > 0">
            <div class="resumeTitle">教育经历</div>
            <div class="resumeArr">
              <div v-for="(item, index) in resume.education_experience" :key="index">
                <div>
                  <span class="schoolName">{{item.schoolName}}</span>
                  <span class="schoolTime">{{item.beginTime + '-' + item.endTime}}</span>
                </div>
                <div class="schoolMajor">
                  <span>{{item.major}}</span>
                  <el-divider direction="vertical"></el-divider>
                  <span>{{item.education}}</span>
                </div>
                <el-divider v-if="index +1 !== resume.education_experience.length"></el-divider>
              </div>
            </div>
          </div>
          <div class="resumeBox" v-if="resume.work_experience !== undefined && resume.work_experience.length > 0">
            <div class="resumeTitle">工作经历</div>
            <div class="resumeArr">
              <div v-for="(item, index) in resume.work_experience" :key="index">
                <div class="schoolName">
                    <span class="major">{{item.unitName}}</span>
                    <span>{{item.beginTime}}-{{item.endTime?item.endTime:'至今'}}</span>
                </div>
                <div class="major">职位名称：<span>{{item.jobName}}</span></div>
                <div class="major" v-if="item.description">工作内容描述：<br /><span v-html="item.description">{{item.description}}</span></div>
                <el-divider v-if="index +1 !== resume.work_experience.length"></el-divider>
              </div>
            </div>
          </div>
          <div class="resumeBox" v-if="resume.workhistory">
            <div class="resumeTitle">自我描述</div>
            <div class="resumeIn" v-html="resume.workhistory">{{resume.workhistory}}</div>
          </div>
        </div>
      </el-col>
      <el-col :span="5">
        <div class="enclosureTip">完善信息，让招聘更简单</div>
        <div class="operation" style="margin-top: 0;">
          <div class="operationBtn chat" @click="goSchool"><i class="el-icon-office-building"></i>完善园所</div>
          <div class="operationBtn Collection" @click="goPost"><i class="el-icon-collection"></i>完善职位</div>
        </div>
        <div class="operation">
          <div class="operationBtn chat" @click="callPhone"><i class="el-icon-phone"></i>打电话</div>
          <div class="operationBtn chat" @click="goChat"><i class="el-icon-chat-line-square"></i>发消息</div>
          <div class="operationBtn Collection" @click="beInterested"><i :class="resume.favorite === 1?'el-icon-star-on':'el-icon-star-off'"></i>感兴趣</div>
        </div>
        <div class="otherPostTitle">
          手机查看
        </div>
        <div class="weChatCode">
            <img :src="weChatCode" alt="">
        </div>
      </el-col>
    </el-row>

    <!-- 打电话 -->
    <el-dialog
      title="打电话"
      :visible.sync="callModal"
      width="30%"
      :before-close="callPhone">
      <img :src="weChatCode" style="width: 100%;" alt="">
    </el-dialog>
  </div>
</template>

<script>
import { loginState } from '@/js/common'
import { getWeChatCode } from '@/js/common.js'

export default {
  watch: {
    $route() {
      this.vid = this.$route.query.vid
      this.upSchool()
      this.getResume();
    }
  },
  data() {
    return {
      callModal: false,
      source: '',
      loading: true,
      vid: "",
      resume: {},
      // 求职状态
      memberList: [
        {
          name: "离职-立即上岗",
          active: 0
        },
        {
          name: "在职-月内上岗",
          active: 1
        },
        {
          name: "在职-考虑机会",
          active: 2
        },
        {
          name: "在职-暂不考虑",
          active: 3
        }
      ],
      weChatCode: ''
    };
  },
  mounted() {
    this.vid = this.$route.query.vid
    if(this.$route.query.source) {
      this.source = this.$route.query.source
    }
    this.upSchool()
    this.getResume();
    this.getCode()
    getWeChatCode(this, 'bossjoin/pages/BossResumeDetail/BossResumeDetail', 'vid=' + this.vid)
  },
  methods: {

    // 打电话
    callPhone() {
      this.callModal = !this.callModal
    },

    // 打开头像
    openAvatar(url) {
      window.open(url)
    },

    // 二维码
    getCode() {
        let obj = {
            page: 'bossjoin/pages/BossResumeDetail/BossResumeDetail',
            scene: 'vid=' + this.vid
        }
        this.api.get('/5d5f4eb649fda', obj).then(r => {

            this.weChatCode = 'data:image/png;base64,' + r
        })
    },

    // 感兴趣
    beInterested() {
        if(loginState()) {
            this.api.get('/5cfe8357756cc', { vid: this.vid }).then(r => {
                this.resume.favorite = this.resume.favorite === 1?0:1
                this.$message({
                    message: this.resume.favorite === 1?'关注成功':'取消关注',
                    type: 'success'
                });
            })
        } else {
            this.$router.push({ path: "/login" })
            this.$message({
                message: '请先登录',
                type: 'success'
            });
        }
    },

    // 发消息
    goChat() {
      this.api.get('/5cef405d39ad5', { page: 1, size: 8 }).then(r => {
        if(r.data.list.length > 0 ) {
          if(r.data.list[0].status === 1) {
            this.$router.push({
              path: '/chat',
              query: {
                vid: this.vid
              }
            })
          } else {
            this.$message({
              message: '请先发布职位或开启职位',
              type: 'success'
            });
            this.$router.push({ path: '/boss/post' })
          }
        }
      })
    },

    // 园所活跃更新
    upSchool() {
      let UserToken = JSON.parse(this.Cookies.get('UserToken'))
      let schoolUser = JSON.parse(this.Cookies.get('schoolUser'))
      if(UserToken && schoolUser) {
        this.api.get('/5fca35dbbd7ff', { sid: schoolUser.sid }).then(r => {
          this.resume = r.data
          if (this.resume.job_confim) {
            this.resume.job_confim = JSON.parse(this.resume.job_confim);
          }
          if (this.resume.selftags) {
            this.resume.selftags = JSON.parse(this.resume.selftags);
          }
          if (this.resume.workhistory) {
            this.resume.workhistory = this.resume.workhistory.replace(/↵/g, "<br>");
          }
          if (this.resume.work_experience) {
            this.resume.work_experience = this.resume.work_experience.replace(/\r\n/g, "<br>")
            this.resume.work_experience = JSON.parse(this.resume.work_experience)
          }
          if (this.resume.education_experience) {
              this.resume.education_experience = JSON.parse(this.resume.education_experience);
          }
        })
      }
    },

    // 获取简历
    getResume() {
      this.loading = true
      let obj = {}
      if(this.source) {
        obj = {
          vid: this.vid,
          source: this.source
        }
      } else {
        obj = {
          vid: this.vid,
        }
      }
      this.api.get('/5cf3c8627109c', obj).then(r => {
        this.loading = false
        this.resume = r.data
        if (this.resume.job_confim) {
          this.resume.job_confim = JSON.parse(this.resume.job_confim);
        }
        if (this.resume.selftags) {
          this.resume.selftags = JSON.parse(this.resume.selftags);
        }
        if (this.resume.workhistory) {
          this.resume.workhistory = this.resume.workhistory.replace(/↵/g, "<br>");
        }
        if (this.resume.work_experience) {
          this.resume.work_experience = this.resume.work_experience.replace(/\r\n/g, "<br>")
          this.resume.work_experience = JSON.parse(this.resume.work_experience)
        }
        if (this.resume.education_experience) {
            this.resume.education_experience = JSON.parse(this.resume.education_experience);
        }
      })
    },

    // 完善职位
    goPost() {
      this.$router.push({
        path: '/boss/post'
      })
    },

    // 完善园所
    goSchool() {
      this.$router.push({
        path: '/boss/school'
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.resume {
  margin-top: 20px;
  background: white;
  padding: 20px;
  .resumeContent {
    > div {
      display: inline-block;
      vertical-align: middle;
    }
    .resumeContentBox {
      margin-left: 10px;
      .resumeContentText {
        font-size: 14px;
        color: #61687c;
        padding-top: 5px;
        i {
          margin-right: 5px;
        }
      }
    }
    .resumeAvatar {
      cursor: pointer;
      position: relative;
      i {
        position: absolute;
        right: 0;
        top: 0;
        font-size: 24px;
      }
      .man {
        color: #4ba1f1;
      }
      .girl {
        color: #fb87b3;
      }
    }
  }
  .resumeBox {
    padding-top: 20px;
    .resumeTitle {
      padding-left: 5px;
      border-left: 3px solid #ff5b12;
    }
    .resumeIn {
      padding-top: 10px;
      font-size: 14px;
      color: #61687c;
      i {
        margin-right: 5px;
      }
      > span {
        margin-bottom: 5px;
        margin-right: 5px;
      }
    }
    .resumeArr {
      padding-top: 10px;
      .schoolTime{
        font-size: 12px;
        margin-left: 30px;
        color: #9fa3b0;
      }
      .schoolMajor {
          padding-top: 10px;
          color: #61687c;
          font-size: 15px;
      }
    }
  }
}

.schoolName {
    >span:nth-child(1) {
        font-size: 15px;
        color: #414a60;
    }
    >span:nth-child(2) {
        font-size: 12px;
        margin-left: 30px;
        color: #9fa3b0;
    }
}
.major {
    padding-top: 10px;
    color: #61687c;
    font-size: 15px;
    font-weight: bold;
    span {
        font-weight: normal;
    }
}

.operation {
  background: white;
  margin-top: 20px;
  padding: 20px;
  .operationBtn {
    text-align: center;
    font-size: 14px;
    padding: 10px 0;
    border-radius: 4px;
    margin-top: 10px;
    cursor: pointer;
    transition: opacity .5s;
    i {
      margin-right: 5px;
    }
  }
  .operationBtn:hover {
    opacity: .8;
  }
  .operationBtn:first-child {
    margin-top: 0;
  }
  .chat {
    color: #ff5b12;
    border: 1px solid #ff5b12;
  }
  .Collection {
    color: white;
    background: #ff5b12;
    border: 1px solid #ff5b12;
  }
}
.enclosureTip {
  margin-top: 20px;
  color: white;
  background: #7aa8f3;
  height: 30px;
  line-height: 30px;
  padding: 0 5px;
  font-size: 12px;
}


.otherPostTitle {
  background: white;
  margin-top: 20px;
  padding: 20px;
  border-bottom: 1px solid #ddd;
}

.weChatCode {
    text-align: center;
    background: white;
    padding-top: 10px;
    img {
        width: 50%;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/boss/resumeDetail.vue